import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { tap, catchError, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { DeviceService } from '../../devices/services/device.service';
import { IBaseSearchRequest } from '../../core/models/base';
import { downloadBlob } from '../../shared/helpers/fileHelper';

export interface ExportState {
  loading: boolean;
  error?: string;
}

@Injectable()
export class DeviceExportStore extends ComponentStore<ExportState> {
  constructor(private deviceService: DeviceService) {
    super({ loading: false });
  }

  // Observable for the loading state
  readonly loading$ = this.select((state) => state.loading);

  // Observable for error state
  readonly error$ = this.select((state) => state.error);

  // Updater to set the loading state
  readonly setLoading = this.updater((state, loading: boolean) => ({
    ...state,
    loading,
    error: undefined, // Clear error when starting a new process
  }));

  // Updater to set an error
  readonly setError = this.updater((state, error: string) => ({
    ...state,
    loading: false,
    error,
  }));

  // Effect to handle the export process
  readonly exportDevices = this.effect((searchRequest$: Observable<IBaseSearchRequest>) =>
    searchRequest$.pipe(
      tap(() => this.setLoading(true)),
      switchMap((searchRequest) =>
        this.deviceService.exportDevices({ searchRequest }).pipe(
          tap((response) => downloadBlob(response, 'geraete-export.xlsx')),
          tap(() => this.setLoading(false)),
          catchError((error) => {
            this.setError(error.message);
            return of(null);
          })
        )
      )
    )
  );
}
